<template>
  <div class="settle-info">
    <el-tabs v-model="activeTab" type="card" @tab-click="handleTabClick">
      <el-tab-pane label="采购商入驻" name="procurement">
        <procurement-settle v-if="activeTab === 'procurement'" :in-member-center="true" />
      </el-tab-pane>
      <el-tab-pane label="供应商入驻" name="supplier">
        <supplier-settle v-if="activeTab === 'supplier'" :in-member-center="true" />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import ProcurementSettle from "@/views/member/procurement_settle"
import SupplierSettle from "@/views/member/supplier_settle"

export default {
  name: "settle",
  components: {
    ProcurementSettle,
    SupplierSettle
  },
  data() {
    return {
      activeTab: this.$route.query.tab === "supplier" ? "supplier" : "procurement"
    }
  },
  watch: {
    "$route.query.tab"(tab) {
      this.activeTab = tab === "supplier" ? "supplier" : "procurement"
    }
  },
  methods: {
    handleTabClick(tab) {
      if (tab.name === this.$route.query.tab) return
      this.$router.replace({
        query: {
          ...this.$route.query,
          tab: tab.name
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.settle-info {
  background: #fff;
  padding: 20px;
}
</style>
